/* eslint-disable no-unused-vars */
import { DatePicker } from "antd";
import dayjs from "dayjs";
// import moment from "moment";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import Select from "react-select";
import { fileToBase64 } from "../../utils/helpers/logicHelper";
import { documentType } from "../../utils/helpers/objectHelpers";
import { attachDocs } from "../../utils/services/users.services";
import CustomDatePicker from "../datePickers/CustomDatePicker";
import Continue from "./Continue";

function Basic({
  dictionary,
  countries,
  associatedRuleId,
  handleClose,
  companyCode,
  title,
  dataCollectionFormType,
  actionType,
}) {
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  const documents = documentType(languageStatus, dictionary);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [formData, setFormData] = useState([
    {
      file_base64: "",
      name: "",
      idType: "",
      issueCountry: "",
      issueNo: "",
      issueDate: "",
      expiryDate: "",
      associatedRuleId: associatedRuleId,
    },
  ]);

  const handleFormChange = (e, index) => {
    let data = [...formData];
    data[index][e.target.name] = e.target.value || e.target.checked;
    setFormData(data);
    if (
      data[index].file_base64 !== "" &&
      data[index].issueCountry !== "" &&
      data[index].issueNo !== ""
    ) {
      setDisabled(false);
    }
  };

  const onChangeFile = async (event) => {
    const allowedExtensions = [
      "jpg",
      "jpeg",
      "png",
      "pdf",
      "doc",
      "docx",
      "JPG",
      "JPEG",
      "PNG",
      "PDF",
      "DOC",
      "DOCX",
    ];
    const sizeLimit = 2097152;
    const selectedFileSize = event.target.files[0].size || "";
    const selectedFileName = event.target.files[0].name || null;
    const fileExtension = selectedFileName.split(".").pop();
    if (typeof selectedFileSize === "undefined") return false;
    else if (
      event.target.files[0] &&
      !allowedExtensions.includes(fileExtension)
    )
      toast.error("File must be an image or document");
    else if (selectedFileSize > sizeLimit) toast.error("File size too large");
    else await event.target.files[0];
  };

  const addFields = () => {
    let obj = {
      file_base64: "",
      name: "",
      idType: "",
      issueCountry: "",
      issueNo: "",
      issueDate: "",
      expiryDate: "",
      associatedRuleId: associatedRuleId,
    };
    setFormData([...formData, obj]);
  };

  const removeFields = (index) => {
    if (index > 0) {
      let data = [...formData];
      data.splice(index, 1);
      setFormData(data);
    }
  };

  const onSubmit = async (data) => {
    const payload = data.map((data) => {
      let attachedDocument = {
        file_base64: data.file_base64,
        idType: actionType,
        issueCountry: data.issueCountry,
        issueNo: data.issueNo,
      };

      if (data?.issueDate) {
        attachedDocument = {
          ...attachedDocument,
          issueDate:
            data?.issueDate !== undefined ? data?.issueDate.toISOString() : "",
        };
      }
      if (data?.expiryDate) {
        attachedDocument = {
          ...attachedDocument,
          expiryDate:
            data?.expiryDate !== undefined
              ? data?.expiryDate.toISOString()
              : "",
        };
      }

      return {
        ...attachedDocument,
      };
    });

    const fileUpload = { customerCode: companyCode, attachedDocument: payload };
   
    setLoading(true);
    try {
      const response = await attachDocs(fileUpload);
      if (response.status === 200) {
        setLoading(false);
        handleClose();
        toast.success(response.data.message);
        setFormData([]);
      }
    } catch (error) {}
    setLoading(false);
  };
  return (
    <form
      className="needs-validation pt-1 ms-5 ps-5"
      onSubmit={(e) => e.preventDefault()}
    >
      <h5 className="title mt-4">{title}</h5>
      <div className="row">
        {/* IDENTITY UPLOAD */}
        {formData.map((i, index) => {
          return (
            <>
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <input
                  type="text"
                  name="issueNo"
                  id="issueNo"
                  className="form-control"
                  onChange={(e) => handleFormChange(e, index)}
                  placeholder={
                    dictionary ? dictionary["l_id_issue_no"] : "Issue Number"
                  }
                  required
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <Select
                  options={countries}
                  isClearable={false}
                  isSearchable={true}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  name="issueCountry"
                  onChange={(option) => {
                    const e = {
                      target: {
                        value: option.iso3Code,
                        name: "issueCountry",
                      },
                    };
                    handleFormChange(e, index);
                  }}
                  placeholder={
                    dictionary ? dictionary["l_issue_country"] : "Issue Country"
                  }
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <CustomDatePicker
                  getDate={(value) => {
                    const e = {
                      target: { value: value, name: "issueDate" },
                    };
                    handleFormChange(e, index);
                  }}
                  showYearDropdown
                  selectDropdownMode
                  // withPortal
                  // setMaxDate={new Date()}
                  placeholderText={
                    dictionary ? dictionary["l_issue_date"] : "Issue Date"
                  }
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <CustomDatePicker
                  getDate={(value) => {
                    const e = {
                      target: { value: value, name: "expiryDate" },
                    };
                    handleFormChange(e, index);
                  }}
                  showYearDropdown
                  selectDropdownMode
                  // withPortal
                  // setMaxDate={new Date()}
                  placeholderText={
                    dictionary ? dictionary["l_expiry_date"] : "Expiry Date"
                  }
                />
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <div className="input-group">
                  <input
                    onChange={async (event) => {
                      onChangeFile(event);
                      const file_base64 = await fileToBase64(
                        event.target.files[0]
                      );
                      const e = {
                        target: {
                          value: file_base64,
                          name: "file_base64",
                        },
                      };
                      handleFormChange(e, index);
                    }}
                    type="file"
                    className="form-control"
                    placeholder="Choose.."
                    readOnly
                  />
                </div>
              </div>

              <div className="row mt-4">
                <p className="subtitle">Is there any other document?</p>
                <div className="row ps-5">
                  <div
                    className="col-xl-4 col-lg-4 col-md-4 mb-3 cols py-3"
                    onClick={() => {
                      addFields();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {/* <input
                      type="button"
                      
                      placeholder={"Full legal name"}
                      required
                    /> */}
                    <span className="ps-4 label">Yes</span>
                  </div>

                  <div
                    className="col-xl-4 col-lg-4 col-md-4 mb-3 cols ms-3 py-3"
                    onClick={() => {
                      removeFields(index);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {/* <input
                      type="button"
                      
                      placeholder={"Full legal name"}
                      required
                    /> */}
                    <span className="ps-4 label">No</span>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>

      <Continue
        dictionary={dictionary}
        onClick={() => {
          onSubmit(formData);
        }}
        loading={loading}
        disabled={disabled}
      />
    </form>
  );
}

export default Basic;
